import React from "react";
import {
  SimpleForm,
  required,
  PasswordInput,
  SelectArrayInput,
  ReferenceArrayInput,
  useEditController,
  AutocompleteArrayInput,
  FormDataConsumer,
  BooleanInput,
} from "react-admin";
import { Grid } from "@material-ui/core";
import CustomEditToolbar from "components/CustomEditToolbar";
import SanitizedGrid from "components/SanitizedGrid";
import EmailInput from "../../components/EmailInput";
import { cloneDeep } from "lodash";
import PermissionLoading from "../../components/PermissionLoading";
import EditWrapper from "../../components/EditWrapper";

const UserEdit = (props: any) => {
  const { id } = props;
  const { record, loading } = useEditController(props);

  const breadcrumb = [
    { link: "/users", title: "Users" },
    { link: `/users/${id}`, title: id },
  ];

  const transform = async (data: any) => {
    if (data.password === "") {
      delete data.password;
    }

    if (data.isSuperAdmin) {
      data.roleIds = [1];
      data.schoolIds = [];
    }

    return data;
  };

  const formatRecord = (res: any) => {
    if (res) {
      if (res.roles) {
        const temp = cloneDeep(res.roles);
        const roleIds = temp.map((item: any) => {
          return item ? item.id : item;
        });
        res.roleIds = roleIds;

        if (res.roleIds.includes(1)) {
          res.isSuperAdmin = true;
        }

        if (res.admin?.schools) {
          const temp = cloneDeep(res.admin.schools);
          const schoolIds = temp.map((item: any) => {
            return item ? item.id : item;
          });
          res.schoolIds = schoolIds;
        }
      }
    }
    return res;
  };

  if (loading) {
    return <PermissionLoading />;
  }

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        customFieldName="email"
        transform={transform}
        {...props}
      >
        <SimpleForm
          record={formatRecord(record)}
          toolbar={<CustomEditToolbar isShowDelete={false} />}
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={4}>
              <EmailInput label="Email" source="email" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <PasswordInput source="password" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <BooleanInput source="isSuperAdmin" label="Set As Super Admin" />
            </Grid>
            <Grid item xs={8}></Grid>

            <FormDataConsumer>
              {({ formData, ...rest }) =>
                !formData.isSuperAdmin && (
                  <>
                    <Grid item xs={4}>
                      <ReferenceArrayInput
                        label="Roles"
                        source="roleIds"
                        reference="roles"
                        filter={{ IsOnlyForAdmin: true }}
                        validate={required()}
                      >
                        <SelectArrayInput optionText="name" />
                      </ReferenceArrayInput>
                    </Grid>
                    <Grid item xs={8}></Grid>

                    <Grid item xs={4}>
                      <ReferenceArrayInput
                        label="Schools"
                        source="schoolIds"
                        reference="schools"
                        validate={required()}
                        filterToQuery={(searchText: any) => {
                          if (searchText !== "") return { search: searchText };
                        }}
                      >
                        <AutocompleteArrayInput optionText="name" />
                      </ReferenceArrayInput>
                    </Grid>
                    <Grid item xs={8}></Grid>
                  </>
                )
              }
            </FormDataConsumer>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default UserEdit;
